import React from 'react'
import styles from './FixedPage.module.scss'

export type FixedPageBodyProps = {
  children: React.ReactNode
}
export const FixedPageBody = ({ children }: FixedPageBodyProps) => {
  // overflow-x-hidden: the module's overflow-y: auto alone computes overflow-x to auto too (CSS
  // Overflow 3), so a grid row's negative gutter margin, which overhangs only empty column padding,
  // scrolled the body sideways.
  return <div className={`d-flex flex-column flex-grow-1 overflow-x-hidden ${styles.fixedBody}`}>{children}</div>
}
